import React from 'react';
import { Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';

/**
 * Banner vermelho com mensagem de erro do provisionamento/desprovisionamento.
 * Mostrado quando status indica falha (failed / partial / *_failed) e há
 * error_message/failed_step preenchidos.
 *
 * Props:
 *  - status: string (ex.: 'deprovision_failed', 'failed', 'partial', 'rollback_failed')
 *  - errorMessage: string
 *  - failedStep: string
 *  - compact: bool (default false) — versão reduzida, usada em coluna de tabela
 */
function ProvisioningErrorBanner({ status, errorMessage, failedStep, compact }) {
    if (!status) return null;
    const isFailureStatus = status === 'failed' || status === 'partial' || status.endsWith('_failed');
    if (!isFailureStatus) return null;
    if (!errorMessage && !failedStep) return null;

    const padding = compact ? '8px 12px' : '14px 18px';
    const fontSize = compact ? 12 : 13;

    return (
        <div style={{
            padding,
            backgroundColor: '#ffebee',
            border: '1px solid #ef9a9a',
            borderLeft: '4px solid #c62828',
            borderRadius: 6,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 10,
            marginBottom: compact ? 0 : 12,
        }}>
            <ErrorIcon style={{ color: '#c62828', marginTop: 2, fontSize: compact ? 18 : 22 }} />
            <div style={{ flex: 1 }}>
                <Typography variant="body2" style={{ fontWeight: 700, color: '#b71c1c', fontSize }}>
                    Falha no {status.includes('deprovision') ? 'desprovisionamento' : 'provisionamento'}
                    {failedStep ? ` — step "${failedStep}"` : ''}
                </Typography>
                {errorMessage && (
                    <Typography variant="body2" style={{ color: '#37474f', marginTop: 4, whiteSpace: 'pre-wrap', fontSize }}>
                        {errorMessage}
                    </Typography>
                )}
            </div>
        </div>
    );
}

export default ProvisioningErrorBanner;
